import { getPgDate } from '../../../../utils/helperMethods';
import {
    FETCH_PG_CONFIG_SUCCESS,
    FETCH_PG_CONFIG_ERROR,
    SAVE_PG_DETAIL_SUCCESS,
    SAVE_PG_DETAIL_ERROR,
    UPDATE_PG_SUCCESS,
    UPDATE_PG_ERROR,
    UPDATE_PG_STATUS_SUCCESS,
    UPDATE_PG_STATUS_ERROR,
    RESET_SAVED_PGS,
} from './pgConfig.constants';

export const initialState = {
    pgList: [],
    savedPgs: {},
    error: {},
};

const updatePgsData = (pgList, payload, initialValues) => {
    const pgData = pgList.map(item => {
        if (item.uniqueId === payload) {
            const date = getPgDate(payload, initialValues);
            return { ...item, ...{ isConfigured: true, date } };
        }
        return item;
    });
    return pgData;
};

const resetPgList = pgList => {
    const pgData = pgList.map(item => {
        return { ...item, ...{ isConfigured: false } };
    });
    return pgData;
};

const isContainValues = values => {
    const keyValues = Object.assign({}, values);
    delete keyValues.status;
    delete keyValues.referenceId;
    delete keyValues.username;
    delete keyValues.soapKey;
    delete keyValues.accountPassword;
    delete keyValues.created;
    delete keyValues.lastUpdated;
    delete keyValues.isUpdated;

    return Object.values(keyValues).every(item => item);
};

const updatePgsStatusData = (savedPgs, payload) => {
    const liveValue =
        (savedPgs && savedPgs[`${payload.uniqueId}ConfLive`]) || {};
    const testValue =
        (savedPgs && savedPgs[`${payload.uniqueId}ConfTest`]) || {};
    if (Object.keys(liveValue).length && isContainValues(liveValue)) {
        if (payload.values.includes('live')) {
            liveValue.status = liveValue.credentials.some(
                cred =>
                    cred.status &&
                    cred.status.length &&
                    cred.status.includes('ENABLED')
            );
        }
    }

    if (Object.keys(testValue).length && isContainValues(testValue)) {
        if (payload.values.includes('test')) {
            testValue.status = testValue.credentials.some(
                cred =>
                    cred.status &&
                    cred.status.length &&
                    cred.status.includes('ENABLED')
            );
        }
    }

    if (Object.keys(liveValue).length && isContainValues(liveValue)) {
        liveValue.isUpdated = true;
        savedPgs[`${payload.uniqueId}ConfLive`] = { ...liveValue };
    } else {
        delete savedPgs[`${payload.uniqueId}ConfLive`];
    }
    if (Object.keys(testValue).length && isContainValues(testValue)) {
        testValue.isUpdated = true;
        savedPgs[`${payload.uniqueId}ConfTest`] = { ...testValue };
    } else {
        delete savedPgs[`${payload.uniqueId}ConfTest`];
    }
    return savedPgs;
};

export const pgConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PG_CONFIG_SUCCESS: {
            return { ...state, pgList: [...action.payload.pgDetails] };
        }
        case FETCH_PG_CONFIG_ERROR:
            return { ...state, ...action.payload };
        case SAVE_PG_DETAIL_SUCCESS: {
            const savedPgs = { ...state.savedPgs, ...action.payload };
            return { ...state, savedPgs };
        }
        case SAVE_PG_DETAIL_ERROR: {
            const error = { ...state, ...action.payload };
            return { ...state, ...error };
        }
        case UPDATE_PG_SUCCESS: {
            const updatedPgList = updatePgsData(
                state.pgList,
                action.payload,
                action.initialValues
            );
            return { ...state, pgList: [...updatedPgList] };
        }
        case UPDATE_PG_ERROR: {
            const error = { ...state, ...action.payload };
            return { ...state, ...error };
        }
        case UPDATE_PG_STATUS_SUCCESS: {
            const updatedSavedPgs = updatePgsStatusData(
                state.savedPgs,
                action.payload
            );
            return { ...state, savedPgs: { ...updatedSavedPgs } };
        }
        case UPDATE_PG_STATUS_ERROR: {
            const error = { ...state, ...action.payload };
            return { ...state, ...error };
        }
        case RESET_SAVED_PGS: {
            const savedPgs = { ...action.payload };
            const updatedPgList = resetPgList(state.pgList);
            return { ...state, savedPgs, pgList: [...updatedPgList] };
        }
        default:
            return state;
    }
};
